var _path, _rect, _g, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4, _path8, _circle, _ellipse2, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse3, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyRaised(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 46,
    viewBox: "0 0 36 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79464 21.6064C1.86957 21.6371 1.13554 22.3959 1.13554 23.3215V42.8471C1.13554 43.8172 1.93902 44.5944 2.90858 44.5622L32.0072 43.5957C32.9322 43.565 33.6663 42.8062 33.6663 41.8806V22.355C33.6663 21.3849 32.8628 20.6077 31.8932 20.6399L2.79464 21.6064Z",
    fill: "url(#paint0_linear_996_3605)",
    stroke: "url(#paint1_linear_996_3605)",
    strokeWidth: 0.447671
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.1746,
    y: 34.4038,
    width: 30.5908,
    height: 18.9514,
    rx: 2.46219,
    transform: "rotate(172.038 34.1746 34.4038)",
    fill: "#2ECC71",
    stroke: "url(#paint2_linear_996_3605)",
    strokeWidth: 0.447671
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.1345,
    y: 19.6864,
    width: 4.87663,
    height: 3.43214,
    rx: 0.671506,
    transform: "rotate(-7.96248 24.1345 19.6864)",
    fill: "#82FDB6",
    stroke: "#1AAF59",
    strokeWidth: 0.149224
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.1978,
    y1: 20.6095,
    x2: 24.3771,
    y2: 20.8642,
    stroke: "#1AAF59",
    strokeWidth: 0.149224
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.3228,
    y1: 21.52,
    x2: 24.5021,
    y2: 21.7746,
    stroke: "#1AAF59",
    strokeWidth: 0.149224
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.0572,
    y1: 20.2094,
    x2: 27.2365,
    y2: 20.4641,
    stroke: "#1AAF59",
    strokeWidth: 0.149224
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.1822,
    y1: 21.1198,
    x2: 27.3615,
    y2: 21.3745,
    stroke: "#1AAF59",
    strokeWidth: 0.149224
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.0452,
    y: 19.9671,
    width: 1.03263,
    height: 2.21448,
    rx: 0.223835,
    transform: "rotate(-7.96248 26.0452 19.9671)",
    stroke: "#1AAF59",
    strokeWidth: 0.149224
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.7152,
    cy: 20.803,
    rx: 4.11302,
    ry: 2.31662,
    transform: "rotate(91.4169 15.7152 20.803)",
    fill: "url(#paint3_radial_996_3605)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8541 20.8972C21.3478 21.9793 21.6308 23.0411 21.6271 23.9367C21.6235 24.8315 21.3346 25.5505 20.6955 25.9694C20.6779 25.981 20.6313 26.0048 20.5637 26.0369C20.4982 26.068 20.4179 26.1045 20.3369 26.1408C20.248 26.1806 20.1573 26.2205 20.0856 26.2521C20.0279 26.2775 19.9825 26.2975 19.9602 26.3077C19.2022 26.6536 18.3011 26.5167 17.4516 25.999C16.6026 25.4815 15.8128 24.5872 15.2879 23.4368C14.7631 22.2863 14.6053 21.1037 14.7709 20.1232C14.9367 19.1423 15.4239 18.3721 16.1819 18.0263C16.2047 18.0159 16.2606 17.9894 16.3345 17.9545C16.4244 17.912 16.5407 17.857 16.6561 17.8031C16.7619 17.7537 16.8675 17.7049 16.9531 17.6668C17.0415 17.6273 17.1018 17.6022 17.1216 17.5966C17.8543 17.3892 18.535 17.6635 19.1631 18.2704C19.7925 18.8785 20.3593 19.8126 20.8541 20.8972Z",
    fill: "#F7CC74",
    stroke: "url(#paint4_linear_996_3605)",
    strokeWidth: 0.149224
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.731 20.4913C22.2451 21.6182 22.3967 22.7707 22.2366 23.718C22.0763 24.6668 21.6104 25.385 20.9108 25.7041C20.2113 26.0233 19.3635 25.9045 18.5419 25.4037C17.7215 24.9037 16.9504 24.0339 16.4363 22.907C15.9221 21.78 15.7706 20.6275 15.9306 19.6802C16.0909 18.7315 16.5569 18.0133 17.2564 17.6942C17.9559 17.375 18.8037 17.4938 19.6253 17.9946C20.4457 18.4946 21.2168 19.3644 21.731 20.4913Z",
    fill: "#FFDF9D",
    stroke: "url(#paint5_linear_996_3605)",
    strokeWidth: 0.447671
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.707 23.8515C16.4745 23.6295 16.2758 23.1461 16.2056 22.9321L15.3231 23.3347C15.4175 23.6853 15.6967 24.0937 15.8246 24.2541L16.707 23.8515Z",
    fill: "url(#paint6_linear_996_3605)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9598 24.2278C16.856 24.144 16.7887 24.0325 16.7681 23.9873L15.8856 24.3899C15.9104 24.4442 16.0238 24.5729 16.0774 24.6304L16.9598 24.2278Z",
    fill: "url(#paint7_linear_996_3605)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.411 21.0619L18.8294 20.3019L18.7746 20.1818L18.1413 20.4708L17.9011 19.9443L19.5781 19.1792L19.9883 20.0782C20.0669 20.2506 20.1105 20.4067 20.1189 20.5467C20.1274 20.6867 20.1049 20.8048 20.0514 20.9011C19.9995 20.9967 19.9221 21.068 19.8193 21.1149C19.6976 21.1704 19.5739 21.1735 19.4482 21.1242C19.3235 21.077 19.2074 20.9775 19.0999 20.8257L18.6765 21.6437L18.411 21.0619ZM19.0522 20.0552L19.201 20.3815C19.2488 20.4862 19.3013 20.5552 19.3586 20.5886C19.4174 20.6213 19.4816 20.6217 19.5512 20.59C19.6176 20.5597 19.6581 20.5102 19.6726 20.4416C19.6881 20.375 19.6724 20.2904 19.6256 20.1878L19.4767 19.8615L19.0522 20.0552Z",
    fill: "url(#paint8_linear_996_3605)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6371 22.3922C20.7017 22.5339 20.7316 22.6727 20.7268 22.8088C20.7246 22.9462 20.6866 23.0702 20.6128 23.1807C20.5416 23.2925 20.4364 23.3802 20.2972 23.4437C20.1596 23.5065 20.0245 23.5285 19.8917 23.5097C19.7599 23.4929 19.6406 23.4408 19.5337 23.3531C19.4294 23.2668 19.3449 23.1529 19.2803 23.0113C19.2204 22.8799 19.1918 22.7566 19.1946 22.6412C19.1974 22.5259 19.2285 22.4286 19.2879 22.3495L18.4174 22.7466L18.1772 22.2202L20.1317 21.3285L20.3719 21.8549L20.1323 21.9642C20.231 21.9712 20.3249 22.0115 20.4138 22.085C20.5027 22.1585 20.5772 22.2609 20.6371 22.3922ZM20.2041 22.3852C20.1535 22.2744 20.0826 22.1964 19.9913 22.1513C19.9025 22.1075 19.8083 22.1083 19.7087 22.1537C19.6107 22.1985 19.5483 22.2691 19.5216 22.3656C19.4959 22.4641 19.5083 22.5688 19.5589 22.6796C19.6104 22.7925 19.68 22.8698 19.7679 22.9116C19.8566 22.9554 19.9516 22.9542 20.0528 22.908C20.154 22.8618 20.2172 22.7909 20.2423 22.6951C20.2683 22.6014 20.2556 22.4981 20.2041 22.3852Z",
    fill: "url(#paint9_linear_996_3605)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.13554,
    y: 22.0808,
    width: 32.5307,
    height: 22.9804,
    rx: 1.71607,
    fill: "#A2BDFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.13554,
    y: 22.0808,
    width: 32.5307,
    height: 22.9804,
    rx: 1.71607,
    fill: "url(#paint10_linear_996_3605)",
    fillOpacity: 0.56
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.13554,
    y: 22.0808,
    width: 32.5307,
    height: 22.9804,
    rx: 1.71607,
    stroke: "url(#paint11_linear_996_3605)",
    strokeWidth: 0.447671
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9942 30.7358C26.4284 30.7358 25.159 32.0052 25.159 33.571C25.159 35.1369 26.4284 36.4063 27.9942 36.4063H33.8886C34.4242 36.4063 34.8585 35.972 34.8585 35.4363V31.7057C34.8585 31.1701 34.4242 30.7358 33.8886 30.7358H27.9942Z",
    fill: "#1E136C",
    stroke: "url(#paint12_linear_996_3605)",
    strokeWidth: 0.447671
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9965,
    cy: 33.5709,
    r: 1.56685,
    fill: "#A3BEFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.4421,
    cy: 14.8488,
    rx: 4.85425,
    ry: 2.31662,
    transform: "rotate(30.9285 10.4421 14.8488)",
    fill: "url(#paint13_radial_996_3605)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9755 10.7474C14.0498 11.2579 14.9497 11.8885 15.5233 12.5763C16.0964 13.2635 16.338 13.9997 16.1185 14.7317C16.1124 14.7518 16.0921 14.8001 16.061 14.8681C16.0309 14.9341 15.9929 15.0137 15.9543 15.0937C15.9119 15.1813 15.8682 15.2702 15.8336 15.3406C15.8058 15.3971 15.784 15.4417 15.7734 15.4638C15.4158 16.2164 14.6381 16.6915 13.6547 16.842C12.6718 16.9924 11.4918 16.8162 10.3497 16.2735C9.20756 15.7308 8.32565 14.9271 7.82145 14.0701C7.31699 13.2127 7.19419 12.3096 7.55179 11.5571C7.56254 11.5344 7.58835 11.4782 7.62242 11.4039C7.66383 11.3136 7.71745 11.1966 7.77111 11.0811C7.8203 10.9751 7.86977 10.8699 7.91067 10.7856C7.95294 10.6985 7.98295 10.6404 7.99447 10.6235C8.42183 9.99311 9.11935 9.76496 9.99065 9.82524C10.8638 9.88565 11.8988 10.2358 12.9755 10.7474Z",
    fill: "#F7CC74",
    stroke: "url(#paint14_linear_996_3605)",
    strokeWidth: 0.149224
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3892 9.87004C14.508 10.4017 15.3657 11.1862 15.8529 12.0143C16.3408 12.8436 16.4464 13.6931 16.1164 14.3876C15.7864 15.0821 15.0611 15.5368 14.1099 15.6823C13.1602 15.8276 12.0102 15.6581 10.8915 15.1265C9.77268 14.5949 8.91497 13.8103 8.42781 12.9823C7.93988 12.1529 7.83431 11.3034 8.16431 10.6089C8.49431 9.91446 9.21962 9.45976 10.1708 9.31424C11.1205 9.16895 12.2705 9.33842 13.3892 9.87004Z",
    fill: "#FFDF9D",
    stroke: "url(#paint15_linear_996_3605)",
    strokeWidth: 0.447671
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7013 15.6776C11.3805 15.6573 10.9173 15.4152 10.7258 15.2966L10.3095 16.1727C10.6074 16.3803 11.0839 16.5132 11.285 16.5536L11.7013 15.6776Z",
    fill: "url(#paint16_linear_996_3605)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1367 15.8022C12.0033 15.8048 11.8801 15.7628 11.8352 15.7415L11.4189 16.6175C11.4728 16.6432 11.6424 16.6687 11.7205 16.6782L12.1367 15.8022Z",
    fill: "url(#paint17_linear_996_3605)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.209 12.4457L11.0401 11.5948L10.9209 11.5381L10.6221 12.1669L10.0995 11.9185L10.8906 10.2537L11.7831 10.6777C11.9543 10.7591 12.0881 10.8506 12.1847 10.9523C12.2812 11.054 12.34 11.1589 12.361 11.267C12.3828 11.3736 12.3695 11.4779 12.321 11.5799C12.2635 11.7008 12.1709 11.7828 12.043 11.826C11.9171 11.8701 11.7642 11.8686 11.5842 11.8216L11.7866 12.7202L11.209 12.4457ZM11.0518 11.2626L11.3758 11.4166C11.4797 11.466 11.5643 11.485 11.6297 11.4737C11.6957 11.4608 11.7452 11.4199 11.778 11.3508C11.8093 11.2848 11.8085 11.2209 11.7754 11.1591C11.7444 11.0981 11.678 11.0435 11.5761 10.9951L11.2521 10.8411L11.0518 11.2626Z",
    fill: "url(#paint18_linear_996_3605)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.769 12.0313C13.9096 12.0981 14.0219 12.1851 14.1058 12.2924C14.1925 12.399 14.2432 12.5183 14.2578 12.6504C14.2753 12.7819 14.2512 12.9167 14.1856 13.0548C14.1207 13.1914 14.0314 13.2952 13.9177 13.3663C13.806 13.4383 13.6811 13.4752 13.5429 13.4769C13.4075 13.4779 13.2695 13.4451 13.1289 13.3783C12.9985 13.3163 12.8973 13.2403 12.8252 13.1502C12.7531 13.0602 12.7143 12.9657 12.7088 12.8669L12.2981 13.7311L11.7755 13.4828L12.6975 11.5424L13.2202 11.7907L13.1072 12.0286C13.1873 11.9704 13.285 11.9408 13.4003 11.9398C13.5157 11.9389 13.6386 11.9693 13.769 12.0313ZM13.4331 12.3047C13.323 12.2524 13.2185 12.2383 13.1196 12.2625C13.0235 12.2861 12.9519 12.3474 12.9049 12.4463C12.8587 12.5436 12.8564 12.6378 12.8981 12.7288C12.9418 12.8208 13.0187 12.8929 13.1287 12.9452C13.2408 12.9984 13.3438 13.0128 13.4379 12.9882C13.5341 12.9646 13.606 12.9026 13.6537 12.8021C13.7015 12.7016 13.7042 12.6067 13.6617 12.5172C13.6213 12.4288 13.5451 12.3579 13.4331 12.3047Z",
    fill: "url(#paint19_linear_996_3605)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5618,
    cy: 10.0222,
    rx: 4.08434,
    ry: 1.47323,
    transform: "rotate(20.138 19.5618 10.0222)",
    fill: "url(#paint20_radial_996_3605)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8561 5.47318C23.4094 6.52602 23.7512 7.57032 23.7976 8.46475C23.8439 9.35833 23.5956 10.0923 22.9809 10.5463C22.964 10.5588 22.9188 10.5852 22.8531 10.621C22.7894 10.6557 22.7112 10.6967 22.6324 10.7374C22.5459 10.7822 22.4576 10.8271 22.3877 10.8626C22.3316 10.8912 22.2873 10.9137 22.2656 10.9251C21.5281 11.3128 20.6208 11.2264 19.7437 10.7569C18.8671 10.2877 18.0286 9.43886 17.4403 8.31954C16.8521 7.20022 16.6285 6.02822 16.7391 5.04007C16.8498 4.05142 17.2933 3.25521 18.0308 2.86758C18.053 2.85593 18.1074 2.82638 18.1792 2.78736C18.2665 2.73995 18.3796 2.67855 18.4918 2.61829C18.5947 2.56304 18.6974 2.50847 18.7807 2.46556C18.8668 2.42122 18.9256 2.3928 18.945 2.38612C19.6651 2.13812 20.36 2.37397 21.021 2.94485C21.6833 3.51691 22.3014 4.4179 22.8561 5.47318Z",
    fill: "#F7CC74",
    stroke: "url(#paint21_linear_996_3605)",
    strokeWidth: 0.149224
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7128 5.01877C24.289 6.11522 24.5047 7.25746 24.3978 8.21221C24.2907 9.16847 23.8656 9.91151 23.185 10.2692C22.5044 10.6269 21.6513 10.5557 20.8029 10.1016C19.9559 9.64815 19.1375 8.82273 18.5612 7.72629C17.9849 6.62984 17.7693 5.4876 17.8762 4.53284C17.9833 3.57659 18.4084 2.83355 19.089 2.47584C19.7696 2.11813 20.6227 2.18939 21.471 2.64351C22.318 3.09691 23.1365 3.92232 23.7128 5.01877Z",
    fill: "#FFDF9D",
    stroke: "url(#paint22_linear_996_3605)",
    strokeWidth: 0.447671
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8844 8.6544C18.6399 8.44576 18.4145 7.97419 18.3324 7.76448L17.4738 8.21573C17.5876 8.56052 17.8892 8.95268 18.0258 9.10566L18.8844 8.6544Z",
    fill: "url(#paint23_linear_996_3605)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1545 9.01592C19.0461 8.93802 18.9727 8.83048 18.9496 8.78645L18.091 9.2377C18.1188 9.29054 18.2392 9.4127 18.2959 9.46717L19.1545 9.01592Z",
    fill: "url(#paint24_linear_996_3605)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4242 5.77399L20.7995 4.99183L20.7381 4.87501L20.1219 5.19887L19.8527 4.68666L21.4844 3.8291L21.9441 4.70376C22.0322 4.8715 22.0844 5.02501 22.1007 5.16428C22.1169 5.30355 22.1011 5.42277 22.053 5.52192C22.0065 5.62026 21.9333 5.69571 21.8333 5.74827C21.7148 5.81054 21.5915 5.82057 21.4633 5.77837C21.3361 5.73816 21.2146 5.64527 21.0988 5.49969L20.7217 6.34012L20.4242 5.77399ZM21.0081 4.7331L21.175 5.05061C21.2285 5.15245 21.2848 5.21844 21.3439 5.24858C21.4044 5.27791 21.4686 5.27478 21.5363 5.2392C21.6009 5.20524 21.6385 5.15359 21.6492 5.08426C21.661 5.01693 21.6406 4.93334 21.5881 4.83349L21.4212 4.51598L21.0081 4.7331Z",
    fill: "url(#paint25_linear_996_3605)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7211 6.978C22.7935 7.11579 22.8311 7.25275 22.834 7.38889C22.8394 7.52621 22.8084 7.65211 22.7409 7.76657C22.676 7.88223 22.5759 7.97563 22.4405 8.04679C22.3066 8.11715 22.1729 8.14665 22.0393 8.13531C21.9068 8.12597 21.7847 8.08053 21.6731 7.999C21.5641 7.91866 21.4734 7.80959 21.401 7.6718C21.3338 7.544 21.2984 7.42244 21.2948 7.30714C21.2911 7.19183 21.3167 7.09299 21.3716 7.01062L20.5246 7.45577L20.2554 6.94356L22.1571 5.94409L22.4263 6.4563L22.1932 6.57881C22.2922 6.58032 22.3881 6.61527 22.481 6.68368C22.5739 6.75209 22.6539 6.8502 22.7211 6.978ZM22.2883 6.99519C22.2317 6.88736 22.1565 6.81346 22.0628 6.77348C21.9718 6.7347 21.8778 6.74078 21.7808 6.79172C21.6854 6.84186 21.6271 6.91583 21.6059 7.01365C21.5857 7.11346 21.6039 7.21728 21.6606 7.32512C21.7183 7.43495 21.7922 7.50826 21.8822 7.54505C21.9733 7.58383 22.0681 7.57735 22.1665 7.52559C22.265 7.47384 22.3241 7.39946 22.3438 7.30246C22.3646 7.20745 22.3461 7.10503 22.2883 6.99519Z",
    fill: "url(#paint26_linear_996_3605)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_996_3605",
    x1: 6.31767,
    y1: 20.0545,
    x2: 30.1848,
    y2: 43.0673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E136C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_996_3605",
    x1: 6.31767,
    y1: 20.0545,
    x2: 30.1848,
    y2: 43.0673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E136C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_996_3605",
    x1: 48.9935,
    y1: 34.2131,
    x2: 48.9935,
    y2: 52.7169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ECC71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AAF59"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_996_3605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7152 20.803) rotate(90) scale(2.31662 4.11302)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBB15A",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8BB3E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_996_3605",
    x1: 16.1479,
    y1: 17.9517,
    x2: 19.9932,
    y2: 26.3801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_996_3605",
    x1: 17.1635,
    y1: 17.4905,
    x2: 21.0037,
    y2: 25.9077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_996_3605",
    x1: 16.4902,
    y1: 23.3763,
    x2: 15.5212,
    y2: 23.8184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_996_3605",
    x1: 16.8979,
    y1: 24.0921,
    x2: 15.9475,
    y2: 24.5256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_996_3605",
    x1: 20.4453,
    y1: 21.0799,
    x2: 18.1373,
    y2: 22.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_996_3605",
    x1: 20.4453,
    y1: 21.0799,
    x2: 18.1373,
    y2: 22.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_996_3605",
    x1: 6.31767,
    y1: 21.5803,
    x2: 29.1417,
    y2: 44.6075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E136C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_996_3605",
    x1: 6.31767,
    y1: 21.5803,
    x2: 29.1417,
    y2: 44.6075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E136C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_996_3605",
    x1: 38.8584,
    y1: 26.2725,
    x2: 31.3587,
    y2: 37.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC1F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191A1C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_996_3605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.4421 14.8488) rotate(90) scale(2.31662 4.85425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBB15A",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8BB3E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_996_3605",
    x1: 7.47776,
    y1: 11.5219,
    x2: 15.8452,
    y2: 15.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_996_3605",
    x1: 7.96214,
    y1: 10.5129,
    x2: 16.3186,
    y2: 14.4837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_996_3605",
    x1: 11.2295,
    y1: 15.4534,
    x2: 10.7724,
    y2: 16.4154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_996_3605",
    x1: 12.002,
    y1: 15.7381,
    x2: 11.5537,
    y2: 16.6816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_996_3605",
    x1: 12.7776,
    y1: 11.1503,
    x2: 11.6888,
    y2: 13.4416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_996_3605",
    x1: 12.7776,
    y1: 11.1503,
    x2: 11.6888,
    y2: 13.4416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_996_3605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5618 10.0222) rotate(90) scale(1.47323 4.08434)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBB15A",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8BB3E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_996_3605",
    x1: 17.9927,
    y1: 2.79504,
    x2: 22.3026,
    y2: 10.9955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_996_3605",
    x1: 18.9849,
    y1: 2.2777,
    x2: 23.2891,
    y2: 10.4674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_996_3605",
    x1: 18.6414,
    y1: 8.19209,
    x2: 17.6986,
    y2: 8.6876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_996_3605",
    x1: 19.085,
    y1: 8.88383,
    x2: 18.1604,
    y2: 9.36979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_996_3605",
    x1: 22.4563,
    y1: 5.67838,
    x2: 20.2108,
    y2: 6.85858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_996_3605",
    x1: 22.4563,
    y1: 5.67838,
    x2: 20.2108,
    y2: 6.85858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB15A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyRaised);
export default __webpack_public_path__ + "static/media/money-raised.ad9f10625e7dcc1be35e88d533c25be1.svg";
export { ForwardRef as ReactComponent };